export const eposta = {
    smtpGetir: (istemci) => istemci.istek('/eposta/smtp'),
    smtpKaydet: (istemci, giris) => istemci.istek('/eposta/smtp', {
        method: 'PATCH',
        body: JSON.stringify(giris),
    }),
    smtpTest: (istemci, giris) => istemci.istek('/eposta/smtp/test', {
        method: 'POST',
        body: JSON.stringify(giris),
    }),
    sablonlariListele: (istemci) => istemci.istek('/eposta/sablonlar'),
    sablonDetay: (istemci, id) => istemci.istek(`/eposta/sablonlar/${id}`),
    sablonGuncelle: (istemci, id, giris) => istemci.istek(`/eposta/sablonlar/${id}`, { method: 'PATCH', body: JSON.stringify(giris) }),
    sablonTestGonder: (istemci, id, giris) => istemci.istek(`/eposta/sablonlar/${id}/test`, {
        method: 'POST',
        body: JSON.stringify(giris),
    }),
    loglar: (istemci) => istemci.istek('/eposta/loglar'),
};
//# sourceMappingURL=eposta.js.map